// extracted by mini-css-extract-plugin
export default {"btn":"FlaggedGuestsRow_btn__eQstx","table-number-cell":"FlaggedGuestsRow_table-number-cell__+nUJP","tr":"FlaggedGuestsRow_tr__Ldgx1"};